import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=eca28a62&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca28a62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eca28a62')) {
      api.createRecord('eca28a62', component.options)
    } else {
      api.reload('eca28a62', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=eca28a62&scoped=true&", function () {
      api.rerender('eca28a62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Q6zFLTDY9BE1/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports